import { store } from 'app/shared/flux/store/configureStore';
import { trackContactRequestFormCsEvent, trackPropertyInfoCsEvent } from 'app/client/analytics';
import { getContactRequestForm, getEnvelope, getPropertyInfo } from 'app/client/analytics/utils';

// https://dataportal.zillowgroup.net/event-registry/5986
export const emitTrackTourRequestSubmitEvent = ({ rentalSubmitId }: { rentalSubmitId: string }) => {
  const state = store.getState();
  const listing = state.currentListingDetails.currentListing;

  trackContactRequestFormCsEvent({
    envelope: getEnvelope({
      eventId: '5986',
      eventVersion: '2',
      templateId: '68',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'home_details',
      trigger_source_nm: 'button_to_submit_instant_tour',
      trigger_object_nm: 'home_details_component|instant_tour_modal',
    },
    semantic: {
      semantic_event_nm: 'instant_tour_submit',
      topic_tag_txt: [],
    },
    ...getPropertyInfo(listing),
    ...getContactRequestForm(rentalSubmitId),
  });
};

// https://dataportal.zillowgroup.net/event-registry/5988
export const emitTrackTourRequestFailedEvent = () => {
  const state = store.getState();
  const listing = state.currentListingDetails.currentListing;

  trackPropertyInfoCsEvent({
    envelope: getEnvelope({
      eventId: '5988',
      eventVersion: '1',
      templateId: '4',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'home_details',
      trigger_source_nm: 'button_to_submit_instant_tour',
      trigger_object_nm: 'home_details_component|instant_tour_modal',
    },
    semantic: {
      semantic_event_nm: 'instant_tour_failure',
      topic_tag_txt: [],
    },
    ...getPropertyInfo(listing),
  });
};

// https://dataportal.zillowgroup.net/event-registry/5987
export const emitTrackTourRequestSuccessEvent = () => {
  const state = store.getState();
  const listing = state.currentListingDetails.currentListing;

  trackPropertyInfoCsEvent({
    envelope: getEnvelope({
      eventId: '5987',
      eventVersion: '1',
      templateId: '4',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'home_details',
      trigger_source_nm: 'button_to_submit_instant_tour',
      trigger_object_nm: 'home_details_component|instant_tour_modal',
    },
    semantic: {
      semantic_event_nm: 'instant_tour_success',
      topic_tag_txt: [],
    },
    ...getPropertyInfo(listing),
  });
};
